<template>
  <div style="background: #f3f3f3; height: 100vh">
    <div class="container">
      <div class="header" style="display: flex; justify-content: space-between">
      <div>
        <h1 style="text-align: left">
          Code Quality, Security & Static <span style="color: #d9534f;">Analysis</span>
        </h1>
        <p style="font-size: 25px; font-weight: 400; margin: 0; text-align: left; padding-top: 1.5rem;">
          Featuring the code quality, security, and static analysis reports of the
          <br>products and tools that we work on.
        </p>
      </div>
      <div>
        <img alt="Logo" src="../assets/image.png" style="height:30px; width:200px;padding-right: 2rem">
      </div>
    </div>
    <p style="padding-top: 2.5rem; font-weight: 600; font-size: 33px; text-align: left;">Products</p>
  </div>
      <div style="padding-left: 4rem ; font-family: Roboto Flex, sans-serif; padding-right:4rem; padding-bottom:2rem">
      <Vue3Marquee
      :speed="2" 
      :duration="250"
      :pause-on-hover="true"
      @on-pause="playState = 'paused'"
      @on-resum="plauState= 'playing'" >
        <div v-for="product in products" :key="product.id" :class="[getBorderColor(product), 'product-card']">
          <div class="product-header" >
            <div>
              <span class="product-title">{{ product.name }}</span>
              <div style="display: flex; gap:15px; text-align: center; font-family:Roboto Flex,sans-serif; font-weight: 600; font-size: 14px;">
                <img src="../assets/Issues.svg" alt="Issues"> 
                <span style="color: #CC4432; padding-top: 0.3rem; letter-spacing: 3px;">{{product.new_violations}} NEW ISSUES </span>
              </div>
            </div>


          <div>
          <div class="product-title1" 
            :style="{
              display: 'flex', 
              alignItems: 'center',
              gap: '10px', 
              backgroundColor: product.quality_gate_details === 'Passed' ? '#5cb85c' : 
                              product.quality_gate_details === 'Failed' ? '#EF7160' : 
                              'transparent',
              padding: '10px', 
              margin: '10px 0',
              height: '50px'
            }">
            <img 
              v-if="product.quality_gate_details === 'Passed'"
              :src="require('@/assets/Passed.svg')" 
              alt="OK Status" 
            />
            <img
              v-else-if="product.quality_gate_details === 'Failed'" 
              :src="require('@/assets/Failed.svg')" 
              alt="Failed Status"
            />

            <!-- Text for product.quality_gate_details -->
            <span>{{ product.quality_gate_details }}</span>
          </div>
        </div>

        <div>
          <div v-if="product.security_issues > 0" 
            class="product-title1" 
          :style="{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '10px', 
                backgroundColor: '#EF7160',
                padding: '10px', 
                margin: '10px 0',
                height: '50px'}">
            <img :src="require('@/assets/Attention.svg')" alt="Attention"/>Needs Attention
          </div>
        </div>

            <div class="last-updated" style="text-align: right;margin-left: auto;">
              <span style="color: #9D9D9D; font-weight: 700; font-size: 19px;">Last updated</span>
              <span style="color: black; font-weight: 700; font-size: 25px;">{{ product.lastUpdated }}</span>
            </div>
          </div> 

          <hr>
            <div class="metrics">
              <div class="metric security">
                <div class="value-group">
                  <div class="value" :style="{ color: getRatingColor(product.security_rating) }">{{ product.security_rating }}</div>
                  <div class="value1">{{ product.security_issues }}</div>
                </div>
                <div style="display: flex; gap: 10px; font-weight: 600; font-size: 17px">
                  <div 
                    :style="{
                      backgroundColor: product.security_issuesH > 0 ? '#FAD4CF' : '#ECECEC',
                      color: product.security_issuesH > 0 ? '#FF2609' : '#000000',
                      borderRadius : '5px',
                      width : '59px',
                      height : '25px',
                    }">
                  {{ product.security_issuesH }} H 
                  </div>
                  <div 
                  :style="{
                        backgroundColor: product.security_issuesM > 0 ? '#FFE9B0' : '#ECECEC',
                        color: product.security_issuesM > 0 ? '#965100' : '#000000',
                        borderRadius : '5px',
                        width : '59px',
                        height : '25px',

                  }"
                  >{{ product.security_issuesM }} M </div>
                <div                     
                :style="{
                      backgroundColor:  '#ECECEC',
                      color: '#000000',
                      borderRadius : '5px',
                      width : '59px',
                      height : '25px',

                    }">{{ product.security_issuesL }} L </div>
              </div>
                <div class="label">Security</div>
              </div>
              <div class="metric reliability">
                <div class="value-group">
                  <div class="value" :style="{ color: getRatingColor(product.reliability_rating) }">{{ product.reliability_rating }}</div>
                  <div class="value1">{{ product.reliability_issues }}</div>
                </div>
                <div style="display: flex; gap: 15px; font-weight: 600; font-size: 17px;">
                  <div
                  :style="{
                      backgroundColor: product.reliability_issuesH > 0 ? '#FAD4CF' : '#ECECEC',
                      color: product.reliability_issuesH > 0 ? '#FF2609' : '#000000',
                      borderRadius : '5px',
                      width : '59px',
                      height : '25px',
                      font: '600px'
                    }"
                  >{{ product.reliability_issuesH }} H </div>

                  <div
                  :style="{
                      backgroundColor: product.reliability_issuesM > 0 ? '#FFE9B0' : '#ECECEC',
                      color: product.reliability_issuesM > 0 ? '#965100' : '#000000',
                      borderRadius : '5px',
                      width : '59px',
                      height : '25px',
                      font: '600px'
                }"
                  >{{ product.reliability_issuesM }} M</div>
                  <div
                  :style="{
                      backgroundColor:  '#ECECEC',
                      color: '#000000',
                      borderRadius : '5px',
                      width : '59px',
                      height : '25px',
                      font: '600px'

                    }">{{ product.reliability_issuesL }} L</div>
                </div>
                <div class="label">Reliability</div>
              </div>
              <div class="metric maintainability">
                <div class="value-group">
                  <div class="value" :style="{ color: getRatingColor(product.sqale_rating) }">{{ product.sqale_rating }}</div>
                  <div class="value1">{{ product.sqale_issues }}</div>
                </div>
                <div style="display: flex; gap: 15px; font-weight: 600; font-size: 17px">
                  <div
                  :style="{
                      backgroundColor: product.sqale_issuesH > 0 ? '#FAD4CF' : '#ECECEC',
                      color: product.sqale_issuesH > 0 ? '#FF2609' : '#000000',
                      borderRadius : '5px',
                      width : '59px',
                      height : '25px',
                      font: '600px'

                }">{{ product.sqale_issuesH }} H</div>
                  <div
                  :style="{
                      backgroundColor: product.sqale_issuesM > 0 ? '#FFE9B0' : '#ECECEC',
                      color: product.sqale_issuesM > 0 ? '#965100' : '#000000',
                      borderRadius : '5px',
                      width : '59px',
                      height : '25px',
                      font: '600px'

                }">{{ product.sqale_issuesM }} M</div>
                  <div
                  :style="{
                      backgroundColor:  '#ECECEC',
                      color:  '#000000',
                      borderRadius : '5px',
                      width : '59px',
                      height : '25px',
                      font: '600px'

                    }">{{ product.sqale_issuesL }} L</div>
                </div>
                <div class="label">Maintainability</div>
              </div>
              <div class="metric coverage">
                <div class="value-group">
                  <div :style="{ color: getCoverageColor(product.coverage) }" class="value">{{ product.coverage }}</div>
                  <div class="value1" v-if="product.coverage !== 'N/A'">%</div>
                </div>
                <div class="progress-bar-container">
                  <div 
                    class="progress-bar" 
                    :style="product.coverage !== 'N/A' ? { width: product.coverage + '%', backgroundColor: getCoverageColor(product.coverage) } : { width: '100%', backgroundColor: 'white' }">
                  </div>
                </div>
                <div class="label" style="padding-top: 0.3rem ;">Coverage</div>
              </div>

            </div>
        </div>
    </Vue3Marquee>

  </div>
  <img src="../assets/Ellipse1.png" alt="Logo" style="height: 100px; width: 200px;">

</div>
</template>

<script>
import { Vue3Marquee } from 'vue3-marquee'
import axios from 'axios';
const moment = require('moment'); 

import { onMounted, ref } from 'vue';

export default {
  components: {
    Vue3Marquee,
  },
  setup() {

    const products = ref([]);
    const convertRatingToLetter = (rating) => {
    if (rating === '5.0') return 'E';
    if (rating === '4.0') return 'D';
    if (rating === '3.0') return 'C';
    if (rating === '2.0') return 'B';
    if (rating === '1.0') return 'A';
    if (rating === '0.0') return 'A';
    if (rating === '0') return 'A';
    return 'N/A'; 
    };

    const getRatingColor = (rating) => {
      switch (rating) {
        case 'A':
          return '#5cb85c'; // Green
        case 'B':
          return '#b0b0b0'; // Grey
        case 'C':
          return '#f0ad4e'; // Yellow
        case 'D':
          return '#d9534f'; // Orange
        case 'E': 
          return '#c9302c'; // Red
        default:
          return '#000'; // Black
      }
    };

      // Add getCoverageColor to assign colors based on coverage ranges
      const getCoverageColor = (coverage) => {
      const cov = parseInt(coverage);
      if (isNaN(cov)) return '#000';

      if (cov >= 0 && cov <= 24) return '#c9302c'; // Red
      if (cov >= 25 && cov <= 49) return '#d9534f'; // Orange
      if (cov >= 50 && cov <= 74) return '#f0ad4e'; // Yellow
      if (cov >= 75 && cov <= 100) return '#5cb85c'; // Green

      return '#000';
    };

    const getBorderColor = (product) => {
    return product.security_issues === 0 ? 'green-border' : 'red-border';
    };

    const fetchData = async () => {
      const url = 'https://sonarqube.reckonsys.com/api/projects/search';
      const apiKey = process.env.VUE_APP_API_KEY;
      const options = {
        headers: {
          'Authorization': `Bearer ${apiKey}`, 
        },
        mode:'cors' 
      };
    
      try {
        const response = await axios.get(url, options);
        
        console.log(response); 
        const data = response.data;

        products.value = await Promise.all(
          data.components.map(async (project) => {
            const metricsResponse = await axios.get(
              `https://sonarqube.reckonsys.com/api/measures/component?component=${project.key}&metricKeys=security_rating,reliability_rating,sqale_rating,coverage,duplicated_blocks,reliability_issues,security_issues,maintainability_issues,lines,quality_gate_details,new_violations`,
              options
            );
            const metrics = metricsResponse.data.component.measures;
            console.log()
            const lastUpdated = project.lastAnalysisDate || 'N/A';
            const formattedDate = lastUpdated !== 'N/A' 
              ? moment(lastUpdated).fromNow()  
              : 'N/A';
           
            const coverageValue = metrics.find((m) => m.metric === 'coverage')?.value;
            const coverage = coverageValue !== undefined ? Math.floor(parseFloat(coverageValue)) : 'N/A';
            let security_issues =  JSON.parse(metrics.find((m) => m.metric === 'security_issues')?.value || '{}')?.total;
            let security_issuesL =  JSON.parse(metrics.find((m) => m.metric === 'security_issues')?.value || '{}')?.LOW;
            let security_issuesM =  JSON.parse(metrics.find((m) => m.metric === 'security_issues')?.value || '{}')?.MEDIUM;
            let security_issuesH =  JSON.parse(metrics.find((m) => m.metric === 'security_issues')?.value || '{}')?.HIGH;
            const qualityGateMetric = metrics.find((m) => m.metric === 'quality_gate_details')?.value;
            const qualityGateObj = JSON.parse(qualityGateMetric || '{}'); // Parse the JSON object
            const qualityGateStatus = qualityGateObj.level === 'OK' ? 'Passed' : qualityGateObj.level === 'ERROR' ? 'Failed' : 'N/A';
            const newViolationsMetric = metrics.find((m) => m.metric === 'new_violations')?.period?.value;
            const newViolations = newViolationsMetric === "0" ? 'NO' : newViolationsMetric || 'N/A';

            return {
              id: project.id,
              name: project.name,
              lastUpdated: formattedDate,
              security_rating: convertRatingToLetter(metrics.find((m) => m.metric === 'security_rating')?.value )|| 'N/A',
              security_issues: security_issues === undefined ?  'N/A': security_issues,
              security_issuesL: security_issuesL === undefined ? 'N/A': security_issuesL,
              security_issuesM: security_issuesM === undefined ? 'N/A': security_issuesM,
              security_issuesH: security_issuesH === undefined ? 'N/A': security_issuesH,
              reliability_rating: convertRatingToLetter(metrics.find((m) => m.metric === 'reliability_rating')?.value) || 'N/A',
              reliability_issues: JSON.parse(metrics.find((m) => m.metric === 'reliability_issues')?.value || '{}')?.total ?? 'N/A',
              reliability_issuesH: JSON.parse(metrics.find((m) => m.metric === 'reliability_issues')?.value || '{}')?.HIGH ?? 'N/A',
              reliability_issuesL: JSON.parse(metrics.find((m) => m.metric === 'reliability_issues')?.value || '{}')?.LOW ?? 'N/A',
              reliability_issuesM: JSON.parse(metrics.find((m) => m.metric === 'reliability_issues')?.value || '{}')?.MEDIUM ?? 'N/A',
              sqale_rating: convertRatingToLetter(metrics.find((m) => m.metric === 'sqale_rating')?.value) || 'N/A',
              sqale_issues: JSON.parse(metrics.find((m) => m.metric === 'maintainability_issues')?.value || '{}')?.total ?? 'N/A',
              sqale_issuesH: JSON.parse(metrics.find((m) => m.metric === 'maintainability_issues')?.value || '{}')?.HIGH ?? 'N/A',
              sqale_issuesM: JSON.parse(metrics.find((m) => m.metric === 'maintainability_issues')?.value || '{}')?.MEDIUM ?? 'N/A',
              sqale_issuesL: JSON.parse(metrics.find((m) => m.metric === 'maintainability_issues')?.value || '{}')?.LOW ?? 'N/A',
              coverage: coverage,
              lines: (metrics.find((m) => m.metric === 'lines')?.value) || 'N/A',
              quality_gate_details: qualityGateStatus,
              new_violations: newViolations

            };
          })
        );

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    onMounted(() => {
      fetchData();

      setInterval(() => {
        location.reload();
      }, 900000);
    });

    const isProjectConfigured = (product) => {
      return (
        product.security_rating === 'N/A' &&
        product.reliability_rating === 'N/A' &&
        product.sqale_rating === 'N/A'
      );
    };

    return {
      products,
      getRatingColor,
      isProjectConfigured,
      getCoverageColor,
      getBorderColor
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto+Flex:opsz,wght@8..144,100..1000&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto+Flex:opsz,wght@8..144,100..1000&family=Roboto+Mono:ital,wght@0,100..700;1,100..700&display=swap');
        body {
            font-family: "Roboto Flex", sans-serif;
            font-optical-sizing: auto;
            background-color: #f3f3f3 !important;
            margin: 0;
            padding: 0;
        }
        .container {
            margin-left: 40px;
            background-color: none;
            padding: 20px;
            border-radius: none;
            font-family: "Roboto Flex", sans-serif;
        }

        .container div{
            max-width: 800px 100px;
        }

        .header h1 {
            font-size: 35px;
            color: black;
            font-weight: 700;
        }
        .header img {
            height: 99px;
            width: 99px;
        }

        .product-title1 img{
          height: 25px !important;
          margin-top:0.1rem;
        }

        .products {
            margin-top: 20px;
        }
        .marquee {
            display: flex;
            white-space: nowrap;
            animation: marquee 50s linear infinite;
        }
        .marquee:hover {
            animation-play-state: paused; 
        }
        @keyframes marquee {
            from {
                transform: translateX(100%);
            }
            to {
                transform: translateX(-100%);
            }
        }
        .product-card {
            display: inline-block;
            max-width: max-content; 
            margin-right: 30px;
            padding: 20px;
            border: 1px solid #ddd;
            border-radius: 8px;
            background-color: white;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        }
        .product-header {
            display: flex;
            flex-direction: row;
            /* justify-content: space-between; */
            gap: 30px;
        }
        .product-title {
            font-size: 30px;
            font-weight: bold;
            padding-bottom: 2rem;
        }

        .product-title img {
          height: 20px !important;
        }

        .product-title1 {
            font-size: 30px;
            padding-bottom: 2rem;
            color: white;
            font-weight: 700;
            white-space: nowrap;
            border-radius: 8px;
            height: 0;
            margin-top: 0.3rem
        }

        .product-score {
            font-size: 16px;
            font-weight: bold;
            color: #c9a22e;
            text-align: left;
        }
        
        .product-score span {
            display: block;
        }
        .last-updated {
            font-size: 12px;
            color: #999;
            line-height: 1.4;
        }
        .last-updated span {
            display: block;
            text-align: right;
        }
        .metrics {
            display: flex;
            justify-content: space-between;
            margin-top: 30px;
            gap: 80px;
        }
        .metric {
            text-align: center;
            font-size: 14px;
            padding-bottom: 2rem;
            padding-left:2rem;
        }
        .metric .value {
            font-size: 62px;
            font-weight: 700;
        }
        .metric .value1 {
            font-size: 32px;
            font-weight: 700;
            color: #606060;
            font-family: 'Roboto Mono', sans-serif;
            padding-top: 27px;
            padding-left: 8px;
        }
        .metric .value2 {
            font-size: 32px;
            font-weight: 700;
            color: #606060;
            font-family: 'Roboto Mono', sans-serif;
            padding-top: 28px;
            padding-bottom: 24px;
        }
        .metric .label {
            font-size: 31px;
            font-weight: 700;
            color: #000000;
            font-family: "Roboto Flex", sans-serif !important ;
            text-align: left;
        }
        .security {
            color: #5cb85c;
        }
        .reliability {
            color: #d9534f;
        }
        .maintainability {
            color: #5cb85c;
        }
        .coverage {
            color:#000000;
        }

        hr {
            display: block;
            height: 1px;
            border: 0;
            border-top: 1px solid #E3E3E3;
            margin-top: 2rem;
        }

        .metric .value-group {
            display: flex;
            gap: 4px; 
            margin-bottom: 0.5rem; 
        }
        .green-border {
          border: 1px solid #5cb85c; /* Green border */
        }

        .red-border {
          border: 1px solid #d9534f; /* Red border */
        }
        .progress-bar-container {
          width: 100%;
          background-color: #D9D9D9;
          border-radius: 10px;
          overflow: hidden;
          height: 16px; 
          margin-top: 10px;
          }

          .progress-bar {
          height: 100%;
          width: 0; 
          background-color: #656565;
          transition: width 0.5s ease-in-out; 
          border-radius: 10px;
          }
</style>
